import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from '../baseQuery';

const dietApi = createApi({
  reducerPath: 'diet',
  tagTypes: ['Diet'],
  baseQuery,
  endpoints(builder) {
    return {
      fetchDiets: builder.query({
        providesTags: (result) =>
          result
            ? [
                { type: 'Diet', id: 'LIST' },
                ...result.map((r) => ({ type: 'Diet', id: r.id })),
              ]
            : [{ type: 'Diet', id: 'LIST' }],
        query: () => ({
          url: `?resource=diet&order=created_at.asc`,
          method: 'GET',
        }),
      }),

      createDiet: builder.mutation({
        // Invalida la lista de dietas y la lista de necesidades dietéticas (que incrustan dietas)
        invalidatesTags: [{ type: 'Diet', id: 'LIST' }, { type: 'DietNeed', id: 'LIST' }],
        query: (data) => ({
          url: `?resource=diet`,
          method: 'POST',
          body: data,
        }),
      }),

      updateDiet: builder.mutation({
        invalidatesTags: (result, error, { id: dietId }) => [
          { type: 'Diet', id: dietId },
          { type: 'Diet', id: 'LIST' },
        ],
        query: ({ id: dietId, submitData }) => ({
          url: `?resource=diet&id=eq.${dietId}`,
          method: 'PATCH',
          body: submitData,
        }),
      }),

      fetchDiet: builder.query({
        providesTags: (result, error, arg) => [{ type: 'Diet', id: arg }],
        query: (dietId) => ({
          url: `?resource=diet&id=eq.${dietId}`,
          method: 'GET',
        }),
      }),

      fetchDietByAthleteId: builder.query({
        providesTags: (result) =>
          result
            ? [
                { type: 'Diet', id: 'LIST' },
                ...result.map((r) => ({ type: 'Diet', id: r.id })),
              ]
            : [{ type: 'Diet', id: 'LIST' }],
        query: (athleteId) => ({
          url: `?resource=diet&athlete=eq.${athleteId}&select=*,athlete_details:athlete(*)&order=created_at.desc`,
          method: 'GET',
        }),
      }),
    };
  },
});

export const {
  useFetchDietsQuery,
  useCreateDietMutation,
  useUpdateDietMutation,
  useFetchDietQuery,
  useFetchDietByAthleteIdQuery,
} = dietApi;

export { dietApi };
